import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { ReactComponent as Close } from '@/assets/img/close.svg';
import '../userTerms.scss';

function UserTermsModal({ show, handleClose, userTerms }) {
  return (
    <Modal
      className="d-flex justify-content-center"
      dialogClassName="modal-user-terms-info"
      show={show}
      onHide={handleClose}
      centered
      scrollable
    >
      <Modal.Title className="d-flex flex-column gap-1 ps-3 pe-3 pt-3 pb-1 justify-content-between">
        <div className="d-flex justify-content-end align-items-center">
          <Close onClick={handleClose} />
        </div>
      </Modal.Title>
      <Modal.Body className="pt-0 d-flex flex-column gap-2">
        <div dangerouslySetInnerHTML={{ __html: userTerms }} />
      </Modal.Body>
    </Modal>
  );
}

UserTermsModal.defaultProps = {
  userTerms: '',
};

UserTermsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  userTerms: PropTypes.string,
};

export default UserTermsModal;
